import React, { useEffect, useState } from "react";
import { Mail, Phone, Circle } from "lucide-react";
import { api } from "@/lib/api";

export default function Contacts() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/contacts").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.put(`/admin/contacts/${id}/read`); load(); };

  return (
    <div>
      <h1 className="font-display text-3xl uppercase text-white mb-6">Contact Submissions</h1>
      <div className="space-y-3">
        {items.map((c) => (
          <div key={c.id} data-testid={`contact-${c.id}`} className={`rounded-xl border p-4 ${c.read ? "border-[#27272A] bg-[#18181B]" : "border-[#D4AF37]/40 bg-[#18181B]"}`}>
            <div className="flex items-start justify-between">
              <div>
                <p className="font-semibold text-white flex items-center gap-2">{!c.read && <Circle size={8} className="fill-[#D4AF37] text-[#D4AF37]" />}{c.first_name} {c.last_name}</p>
                <div className="flex flex-wrap gap-3 mt-1 text-xs text-zinc-400">
                  <a href={`mailto:${c.email}`} className="inline-flex items-center gap-1 hover:text-white"><Mail size={12} />{c.email}</a>
                  {c.phone && <span className="inline-flex items-center gap-1"><Phone size={12} />{c.phone}</span>}
                </div>
              </div>
              <span className="text-[10px] font-oswald tracking-widest bg-[#27272A] text-zinc-300 px-2 py-1 rounded">{c.reason}</span>
            </div>
            <p className="text-sm text-zinc-300 mt-3">{c.message}</p>
            {!c.read && <button data-testid={`mark-read-${c.id}`} onClick={() => markRead(c.id)} className="mt-3 text-xs text-[#D4AF37] hover:underline">Mark as read</button>}
          </div>
        ))}
        {items.length === 0 && <div className="rounded-xl border border-[#27272A] p-10 text-center text-zinc-500">No submissions yet.</div>}
      </div>
    </div>
  );
}
